import React, { useState, useEffect } from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import { WifiOff, Wifi } from '@mui/icons-material';

const OfflineIndicator: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (isOnline) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Tooltip title="Online">
          <Chip
            size="small"
            icon={<Wifi />}
            label="Online"
            color="success"
            sx={{ height: 20 }}
          />
        </Tooltip>
      </Box>
    );
  }

  return (
    <Tooltip title="Offline - Daten werden lokal gespeichert">
      <Chip
        size="small"
        icon={<WifiOff />}
        label="Offline"
        color="error"
        sx={{ height: 20 }}
      />
    </Tooltip>
  );
};

export default OfflineIndicator; 